import config from 'shared/config'

/**
 * Export config...
 */
export default {
    ...config
}


// WEBPACK FOOTER //
// ./src/enterprise/config.js